var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.51579 5.6523L9.18245 9.81897L15.8491 5.6523V8.1523H17.5158V3.98564C17.5158 3.06897 16.7658 2.31897 15.8491 2.31897H2.51579C1.59912 2.31897 0.857454 3.06897 0.857454 3.98564L0.849121 13.9856C0.849121 14.9023 1.59912 15.6523 2.51579 15.6523H10.8491V13.9856H2.51579V5.6523ZM15.8491 3.98564L9.18245 8.1523L2.51579 3.98564H15.8491Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5156 12.319V15.6523C17.5156 16.569 16.7656 17.319 15.849 17.319C14.9323 17.319 14.1823 16.569 14.1823 15.6523V11.9023C14.1823 11.669 14.3656 11.4856 14.599 11.4856C14.8323 11.4856 15.0156 11.669 15.0156 11.9023V15.6523H16.6823V11.9023C16.6823 11.3498 16.4628 10.8199 16.0721 10.4292C15.6814 10.0385 15.1515 9.81897 14.599 9.81897C14.0464 9.81897 13.5165 10.0385 13.1258 10.4292C12.7351 10.8199 12.5156 11.3498 12.5156 11.9023V15.6523C12.5156 17.494 14.0073 18.9856 15.849 18.9856C17.6906 18.9856 19.1823 17.494 19.1823 15.6523V12.319H17.5156Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendReport);
export default __webpack_public_path__ + "static/media/send-report.992107b0257c43bf7934c22815d72c72.svg";
export { ForwardRef as ReactComponent };